<template>
  <div>

    <footer-disclaimer v-if="showDisclaimer()"></footer-disclaimer>

    <app-content-default-template class="app-content-default-template-footer">
      <footer>
        <div class="footer-inner">

          <div class="accordions">
            <accordion label="The Technology" accordionType="link" routeName="TheTechnology"></accordion>

            <accordion label="Quick Links" :closeAccordion="closeAccordions">
              <ul>
                <li v-for="(link, index) in setQuickLinksFirstColumn" v-bind:key="index">
                  <a :href="getRoutePath(link.name)" v-on:click.prevent="onNavItemClick(link.name, link.scrollToSubscriptionWidget)">
                    {{ link.ui.label }}
                  </a>
                </li>
              </ul>
            </accordion>

            <accordion label="&nbsp;" :closeAccordion="closeAccordions" v-if="isQuickLinksSecondColumnVisible">
              <ul>
                <li v-for="(link, index) in setQuickLinksSecondColumn" v-bind:key="index">
                  <a :href="getRoutePath(link.name)" v-on:click.prevent="onNavItemClick(link.name, link.scrollToSubscriptionWidget)">
                    {{ link.ui.label }}
                  </a>
                </li>
              </ul>
            </accordion>

            <accordion label="Site Information">
              <ul>
                <li v-for="(link, index) in getSiteInfoLinks" v-bind:key="index">
                  <a :href="getRoutePath(link.name)" v-on:click.prevent="onNavItemClick(link.name)">
                    {{ link.ui.label }}
                  </a>
                </li>
              </ul>
            </accordion>

            <accordion label="Contact Us" class="contact-collapse">
              <p>
                Loyal Solutions A/S<br>
                Edvard Thomsens Vej 10, 6th floor<br>
                DK-2300 Copenhagen S<br>
                Danmark<br>
                CVR: 28850263<br><br>

                <a href="tel:+45 33 26 78 33">+45 33 26 78 33</a><br>
              </p>

              <p>
                <i>Write to us</i><br>
                <a href="mailto:info@loyalsolutions.eu?subject=I would like to be contacted by Loyal Solutions">info@loyalsolutions.eu</a>
              </p>

              <p style="margin-bottom: 10px;">
                <i>Find us on</i>
              </p>

              <a href="https://www.linkedin.com/company/loyal-solutions" target="_blank" rel="noopener">
                <img src="@/assets/images/socials/linkedin.png" alt="Linkedin">
              </a>
            </accordion>

            <accordion label="About us" accordionType="link" routeName="AboutUs" class="about-link"></accordion>
            <accordion label="Contact Us" accordionType="link" routeName="Contact" class="contact-link"></accordion>
          </div>

          <div class="footer-bottom">
            <div class="footer-bottom-inner">

              <div class="logo-wrapper">
                <div class="logo-wrapper-inner">
                  <app-main-logo></app-main-logo>
                </div>
              </div>

              <div class="reserved-ls">
                <a :href="getRoutePath('Copyrights')" v-on:click.prevent="onNavItemClick('Copyrights')">&copy; Loyal Solutions A/S</a>
              </div>

            </div>
          </div>
        </div>
      </footer>
    </app-content-default-template>
  </div>
</template>

<script>
    import Accordion from '@/components/layout/footer/Accordion';
    import AppMainLogo from '@/components/ui/logo/AppMainLogo';
    import AppContentDefaultTemplate from '@/components/layout/templates/content/AppContentTemplateDefault';
    import FooterDisclaimer from "@/components/ui/disclaimer/Disclaimer";

    /* Mixins */
    import { mixinRoutesHandler } from '@/mixins/routes-handler';
    import { mixinWindowResizeListener } from '@/mixins/window-resize-listener';

    export default {
      name: 'AppFooter',

      mixins: [mixinRoutesHandler, mixinWindowResizeListener],

      components: {
          Accordion, AppMainLogo, AppContentDefaultTemplate, FooterDisclaimer,
      },

      data: function () {
        return {
          windowWidth: 0,
          quickLinks: [],
          siteInfoLinks: [],
          closeAccordions: false,
          subscribe: {
            ui: {
              label: 'Subscribe',
            },
            scrollToSubscriptionWidget: true,
            name: 'InvestorRelationsContact'
          },
        }
      },

      methods: {
        getRoutePath(routeName) {
          return this._mixinGetRoutePath(routeName);
        },

        onNavItemClick(routeName, scrollToSubscriptionWidget = false) {
          this.closeAccordions = true;

          if (scrollToSubscriptionWidget && routeName == this.subscribe.name) {
            if (this.$route.name != this.subscribe.name) {
              this.$router.push({
                name: routeName,
                params: { scrollToSubscriptionWidget: scrollToSubscriptionWidget, },
              });
            } else {
              this.$root.$emit('scroll-to-target-elm', { behavior: 'smooth'});
            }
          } else {
            this._mixinGoToRouteName(routeName);
          }
        },

        setQuickLinks() {
          this.quickLinks = this._mixinRoutesHandler_getRoutesAVisibleIn('footerQuickLinks');
          this.quickLinks.forEach((link, index) => {
            if (index === this.quickLinks.length - 1) {
              this.quickLinks.push(this.subscribe);
            }
          });
        },

        setSiteInfoLinks() {
          this.siteInfoLinks = this._mixinRoutesHandler_getRoutesFiltered([
              'Copyrights',
              'DataProtection',
              'UseOfCookies',
              'Sitemap'
          ]);
        },

          showDisclaimer() {
            const routes       = this.$router.options.routes;
            const currentRoute = this.$route.name;

            let isDisclaimerVisible = false;
            routes.forEach((route) => {
              if ('children' in route) {
                const children = route.children;
                children.forEach((child) => {
                  if (child.name === currentRoute) {
                    isDisclaimerVisible = ('footerDisclaimer' in child && child.footerDisclaimer);
                  }
                });
              } else {
                if (route.name === currentRoute) {
                  isDisclaimerVisible = ('footerDisclaimer' in route && route.footerDisclaimer);
                }
              }
            });

            return isDisclaimerVisible;
          }
        },

      computed: {
        setQuickLinksFirstColumn() {
          const quickLinks = this.quickLinks;
          const length     = quickLinks.length;

          if (this.windowWidth > 991) {
            return quickLinks.filter((x, i) => {
              return i < Math.ceil((length / 2));
            });
          }

          return quickLinks;
        },

        setQuickLinksSecondColumn() {
          const quickLinks = this.quickLinks;
          const length     = quickLinks.length;

          return quickLinks.filter((x, i) => {
            return i >= Math.ceil((length / 2));
          });
        },
        
        getSiteInfoLinks() {
          return this.siteInfoLinks;
        },

        isQuickLinksSecondColumnVisible() {
          return this.windowWidth > 991;
        }
      },

      mounted() {
        this.setQuickLinks();
        this.setSiteInfoLinks();
      },

      watch: {
        'mixinWindowResizeListenerData.width': function (newVal) {
          this.windowWidth = newVal;
        },

        '$route': function () {
          this.showDisclaimer();
        },
      },
    }
</script>

<style scoped lang="scss">
  
  .app-content-template-default {
    background-color: #1b1e21;

    font-size: 15px;

    footer {
      width: 100%;
      overflow: hidden;
      padding: 16px 0;

      .accordions {
        padding-bottom: 10px;
        margin-bottom: 30px;

        a {
          font-weight: normal;
        }
      }

      .contact-collapse {
        display: none;

        p {
          font-size: 15px;
        }
      }

      .logo-wrapper {
        float: left;
      }

      .logo-wrapper-inner {
        margin-bottom: 30px;
      }

      .footer-bottom {
        width: 100%;
        padding: 0 8px;

        .footer-bottom-inner {
          width: 100%;
          display: flex;
          flex-direction: column;

          .reserved-ls {
            display: flex;
            align-items: center;

            a {
              color: white;
              font-weight: normal;
            }
          }
        }
      }

      @media (min-width: $lgBreakpoint) {
        .contact-collapse {
          display: block;
        }

        .contact-link, .about-link {
          display: none;
        }

        .footer-inner {
          max-width: $appWidth;
          margin: auto;

          .accordions {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .accordion:nth-child(1) {
              display: none;
            }
          }
        }

        .logo-wrapper-inner {
          width: 100%;
          display: block;
          overflow: hidden;
          margin-bottom: 0;
        }

        .footer-bottom {
          .footer-bottom-inner {
            border-top: 1px solid #cecece;
            padding-top: 70px;
            flex-direction: row;
            justify-content: space-between;
          }
        }
      }
    }
  }
</style>
